export enum RelatedFilterValidation{
    MustHaveValue = 0,
    MustNotHaveValue = 1 
}